import documentTypes from './documentTypes'

import { QueryResolvers } from '../../../../../generated/graphql'

const documents: QueryResolvers = {
    documentTypes,
}

export default documents
